import Axios from "../../api/Axios";
const BASE_URL = "OtherReports/";
export const EndpointOtherReports = {
    GetNonInventoryReport: "GetNonInventoryReport",
};
export const createAPIEndpointOtherReports = () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL+Endpoint)};
};